import * as Tone from 'tone';


// Coin Sound
function playCoinSound() {
  const gainNode = new Tone.Gain(0.05).toDestination(); // Adjust value between 0-1
  const synth = new Tone.Synth({
    oscillator: {
      type: 'pulse',
      width: 0.3
    },
    envelope: {
      attack: 0.001,
      decay: 0.05,
      sustain: 0.4,
      release: 0.05
    }
  }).connect(gainNode); // Connect to gain node instead of destination

  // Trigger two quick notes for the coin effect
  synth.triggerAttackRelease('A5', 0.05);
  synth.triggerAttackRelease('E6', 0.05, "+0.03");
}


// Jump Sound
function playJumpSound() {
  const gainNode = new Tone.Gain(0.5).toDestination();
  const synth = new Tone.Synth({
    oscillator: { type: 'sawtooth' },
    envelope: { attack: 0.01, decay: 0.1, sustain: 0.1, release: 0.0 }
  }).connect(gainNode);

  // Set the synth volume to a quieter level
  synth.volume.value = -12; // Lower the volume by 12 dB

  // Set the initial pitch for the jump sound
  synth.triggerAttack('A4');

  // Schedule the pitch slide to G5 after a short delay for a slide effect
  synth.frequency.rampTo('G5', 0.1); // Slide up over 0.1 seconds

  // Release the note shortly after the slide
  synth.triggerRelease('+0.15');
}

// One-Up Sound
function playOneUpSound() {
  const synth = new Tone.Synth({
    oscillator: { type: 'triangle' },
    envelope: { attack: 0.01, decay: 0.2, sustain: 0.3, release: 0.3 }
  }).toDestination();

  // Play an arpeggio sequence
  const now = Tone.now();
  synth.triggerAttackRelease('C4', 0.1, now);
  synth.triggerAttackRelease('E4', 0.1, now + 0.1);
  synth.triggerAttackRelease('G4', 0.1, now + 0.2);
  synth.triggerAttackRelease('C5', 0.1, now + 0.3);
}

function playKnifeAttackSound() {
  // Create a noise source for the main "swish" sound of the knife attack
  const noise = new Tone.Noise("white").start();
  
  // Use a bandpass filter to emphasize a "swish" sound, with a focused frequency
  const filter = new Tone.Filter({
    type: "bandpass",
    frequency: 1200, // Frequency that adds a touch of sharpness
    Q: 2.5           // Moderate Q to keep a bit of musicality
  });

  // Create an envelope to control the volume of the noise for a quick "swoosh"
  const envelope = new Tone.AmplitudeEnvelope({
    attack: 0.01,    // Quick attack for instant impact
    decay: 0.1,      // Short decay to make it a quick effect
    sustain: 0.0,    // No sustain
    release: 0.05    // Quick release to end the sound
  }).toDestination();

  // Connect noise to the filter, then to the envelope
  noise.connect(filter);
  filter.connect(envelope);

  // Trigger the envelope to play the "swoosh" effect
  envelope.triggerAttackRelease(0.15);

  // Stop the noise after the envelope release time
  setTimeout(() => {
    noise.stop();
  }, 150); // Duration in ms

  // Create a subtle oscillator for a quick, subtle pitch drop
  const oscillator = new Tone.Oscillator({
    type: "sine",       // Sine wave for a smooth, subtle tonal quality
    frequency: 500      // Start frequency
  }).start();

  // Envelope for the oscillator to give it a sharp attack and quick decay
  const oscEnvelope = new Tone.AmplitudeEnvelope({
    attack: 0.005,
    decay: 0.1,
    sustain: 0,
    release: 0.05
  }).toDestination();

  // Connect the oscillator to its envelope
  oscillator.connect(oscEnvelope);

  // Trigger the pitch drop with a quick slide down
  oscillator.frequency.rampTo(300, 0.1);
  oscEnvelope.triggerAttackRelease(0.15);

  // Stop the oscillator after the envelope release time
  setTimeout(() => {
    oscillator.stop();
  }, 150); // Duration in ms
}

function playHeartCollectSound() {
  // Create a synth with a bell-like sound for a sparkly heart collection effect
  const synth = new Tone.MetalSynth({
    frequency: 500,      // Sets the starting frequency for a chime-like sound
    envelope: {
      attack: 0.01,      // Quick attack to make it sharp
      decay: 0.2,        // Moderate decay to let it fade naturally
      release: 0.3       // Short release for a quick finish
    },
    harmonicity: 5.1,    // Adds bell-like overtones
    modulationIndex: 32  // High modulation index for a shimmering effect
  }).toDestination();

  // Play a single sparkly note with a soft frequency ramp
  synth.triggerAttackRelease('C6', 0.2);

  // Optionally, add a soft secondary effect to enhance the sparkle
  const secondarySynth = new Tone.Synth({
    oscillator: { type: 'sine' },
    envelope: { attack: 0.005, decay: 0.1, sustain: 0, release: 0.2 }
  }).toDestination();

  // Trigger a gentle high-pitched note just after the initial sound
  secondarySynth.triggerAttackRelease('G6', 0.1, "+0.1");
}

function playAppleCollectSound() {
  // Create a synth for the main "pop" sound
  const synth = new Tone.Synth({
    oscillator: { type: 'sine' }, // Sine wave for a soft, round sound
    envelope: {
      attack: 0.01, // Quick attack for a snappy sound
      decay: 0.1,   // Short decay to make it crisp
      sustain: 0.1, // Brief sustain for fullness
      release: 0.2  // Soft release to fade naturally
    }
  }).toDestination();

  // Trigger a single note for the "pop" effect
  synth.triggerAttackRelease('C5', 0.15);

  // Add a soft noise burst for a crunchy texture
  const noise = new Tone.NoiseSynth({
    noise: { type: 'white' }, // White noise for a natural, subtle crunch
    envelope: {
      attack: 0.01,
      decay: 0.08,  // Quick decay to make it brief
      sustain: 0,
      release: 0.1 // Quick release to avoid lingering
    }
  }).toDestination();

  // Trigger the noise burst slightly after the pop
  noise.triggerAttackRelease(0.1, "+0.05");
}

function playSlingCollectSound() {
  // Create a synth for the initial "swoosh" sound
  const swooshSynth = new Tone.Synth({
    oscillator: { 
      type: 'triangle',  // Triangle wave for a smooth swoosh
      width: 0.3
    },
    envelope: {
      attack: 0.05,
      decay: 0.2,
      sustain: 0.2,
      release: 0.3
    }
  }).toDestination();

  // Create a synth for the "power up" sound
  const powerSynth = new Tone.Synth({
    oscillator: { 
      type: 'square',    // Square wave for a more electronic sound
      width: 0.5
    },
    envelope: {
      attack: 0.01,
      decay: 0.3,
      sustain: 0.1,
      release: 0.2
    }
  }).toDestination();

  // Add a filter for the power-up effect
  const filter = new Tone.Filter({
    type: "bandpass",
    frequency: 800,
    Q: 2
  }).toDestination();

  powerSynth.connect(filter);

  // Play the sequence
  const now = Tone.now();
  
  // Initial swoosh
  swooshSynth.triggerAttackRelease('G4', 0.2, now);
  
  // Power-up sequence
  powerSynth.triggerAttackRelease('C5', 0.1, now + 0.1);
  powerSynth.triggerAttackRelease('E5', 0.1, now + 0.2);
  
  // Final confirmation tone
  swooshSynth.triggerAttackRelease('G5', 0.15, now + 0.3);
  
  // Filter sweep for added effect
  filter.frequency.rampTo(2400, 0.3, now);
}


function playHurtSound() {
  const gainNode = new Tone.Gain(0.35).toDestination();
  const synth = new Tone.Synth({
    oscillator: { type: 'sine' },
    envelope: { attack: 0.001, decay: 0.15, sustain: 0.0, release: 0.05 }
  }).connect(gainNode);

  const now = Tone.now();
  synth.triggerAttackRelease('E6', 0.04, now);
  synth.frequency.rampTo('A4', 0.12, now);
  synth.triggerRelease(now + 0.13);
}

function playRoachDeathSound() {
  // Crinkling paper: two quick filtered pink-noise bursts
  const now = Tone.now();
  for (const [time, freq] of [[now, 2200], [now + 0.08, 1400]]) {
    const noise = new Tone.Noise('pink').start(time).stop(time + 0.25);
    const filter = new Tone.Filter({ type: 'bandpass', frequency: freq, Q: 1.5 });
    const env = new Tone.AmplitudeEnvelope({
      attack: 0.005, decay: 0.1, sustain: 0, release: 0.04,
    }).toDestination();
    noise.connect(filter);
    filter.connect(env);
    env.triggerAttackRelease(0.1, time);
  }
}

function playSpiderDeathSound() {
  // Light descending squeak — spider is small
  const gain = new Tone.Gain(0.45).toDestination();
  const synth = new Tone.Synth({
    oscillator: { type: 'sine' },
    envelope: { attack: 0.005, decay: 0.15, sustain: 0, release: 0.05 },
  }).connect(gain);
  const now = Tone.now();
  synth.triggerAttack('A5', now);
  synth.frequency.rampTo('D4', 0.15, now);
  synth.triggerRelease(now + 0.15);
}

function playCactusDeathSound() {
  // Dry crack: sharp noise burst + low thud
  const now = Tone.now();
  const noise = new Tone.NoiseSynth({
    noise: { type: 'white' },
    envelope: { attack: 0.001, decay: 0.09, sustain: 0, release: 0.03 },
  }).toDestination();
  noise.triggerAttackRelease(0.09, now);

  const thud = new Tone.Synth({
    oscillator: { type: 'sine' },
    envelope: { attack: 0.001, decay: 0.12, sustain: 0, release: 0.05 },
  }).toDestination();
  thud.triggerAttack('C2', now);
  thud.frequency.rampTo('G1', 0.1, now);
  thud.triggerRelease(now + 0.12);
}

function playBombExplosionSound() {
  const now = Tone.now();

  // Sub-bass thud — deep sine drop
  const bassGain = new Tone.Gain(1.0).toDestination();
  const thud = new Tone.Synth({
    oscillator: { type: 'sine' },
    envelope: { attack: 0.001, decay: 0.6, sustain: 0, release: 0.2 },
  }).connect(bassGain);
  thud.triggerAttack('C1', now);
  thud.frequency.rampTo('C0', 0.5, now);
  thud.triggerRelease(now + 0.6);

  // Second sine layer for body
  const midGain = new Tone.Gain(0.6).toDestination();
  const body = new Tone.Synth({
    oscillator: { type: 'triangle' },
    envelope: { attack: 0.001, decay: 0.35, sustain: 0, release: 0.1 },
  }).connect(midGain);
  body.triggerAttack('G1', now);
  body.frequency.rampTo('C1', 0.3, now);
  body.triggerRelease(now + 0.35);

  // Noise burst filtered low for rumble, not crack
  const noiseGain = new Tone.Gain(0.4).toDestination();
  const filter = new Tone.Filter({ type: 'lowpass', frequency: 600, rolloff: -24 });
  filter.connect(noiseGain);
  const noise = new Tone.NoiseSynth({
    noise: { type: 'brown' },
    envelope: { attack: 0.001, decay: 0.4, sustain: 0, release: 0.15 },
  }).connect(filter);
  noise.triggerAttackRelease(0.4, now);
}

export {
  playCoinSound,
  playJumpSound,
  playOneUpSound,
  playKnifeAttackSound,
  playHeartCollectSound,
  playAppleCollectSound,
  playSlingCollectSound,
  playHurtSound,
  playRoachDeathSound,
  playSpiderDeathSound,
  playCactusDeathSound,
  playBombExplosionSound,
}
